import { render, staticRenderFns } from "./InvestorTab.vue?vue&type=template&id=f23b9936"
import script from "./InvestorTab.vue?vue&type=script&lang=js"
export * from "./InvestorTab.vue?vue&type=script&lang=js"
import style0 from "./InvestorTab.vue?vue&type=style&index=0&id=f23b9936&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports